import { PASUR_SEAT_COUNTS, type PasurSeatCount } from "@bing/engine-pasur";
import type { OnlineJoin } from "./private-table";

/**
 * THE GAMES WHOSE TABLE SIZE IS A ROOM — today پاسور's: ONE ROOM PER SIZE (operator, 2026-10-20,
 * item 1: «public tables for 2 and for 4 players, and in a private table the owner picks 2 or 4
 * (default 4)»). Shared by the lobby's courier (`prefs.ts`), the host's picker (`GameSettings`) and
 * the game's container (`PasurOnlineGame`) — a platform helper with no copy of its own, which is why
 * its name is not the game's (`pasur-copy.test.ts` holds every پاسور-named module to the game).
 *
 * A room's name and `maxClients` are fixed at the game-server's `define()`, so a size IS a room type —
 * منچ's per-size private rooms — and the two public sizes are two QUEUES, as تخته نرد's two lengths
 * are. The four-seat rooms keep their plain names (every cached bundle and every link asks for them);
 * a room for two carries its size in the name, as `mensch2-private` does. These are the names
 * `server.ts` registers — `pasur-tables-for-two.test.tsx` reads them off it, size for size.
 */

/** The size a table is when nobody chose one: four, two partnerships — the operator's default. */
export const DEFAULT_PASUR_SEATS: PasurSeatCount = 4;

/** A size the engine plays, or the default: a stale, absent or crafted value lands at the four-seat
 *  table — never at a room the server does not define. */
export function pasurSeatsOrDefault(raw: unknown): PasurSeatCount {
  return (PASUR_SEAT_COUNTS as readonly unknown[]).includes(raw)
    ? (raw as PasurSeatCount)
    : DEFAULT_PASUR_SEATS;
}

const sizeSuffix = (seats: PasurSeatCount): string => (seats === 4 ? "" : String(seats));

/** The PUBLIC room (the quick-match queue) of a size. */
export function pasurOnlineRoom(seats: PasurSeatCount): string {
  return `pasur${sizeSuffix(seats)}-online`;
}

/** The PRIVATE room (a host's own table) of a size. */
export function pasurPrivateRoom(seats: PasurSeatCount): string {
  return `pasur${sizeSuffix(seats)}-private`;
}

/**
 * The size a CREATE asks for: the host's pick on «تنظیمات میز» (the intent's `seats`), else four — a
 * table created without the settings screen (a friend invited from the list) is the default table.
 * Every other way in (a quick-match, a join by id, a re-join) names no private room at all.
 */
export function pasurSeatsOfJoin(join: OnlineJoin): PasurSeatCount {
  return join.kind === "create" ? pasurSeatsOrDefault(join.seats) : DEFAULT_PASUR_SEATS;
}
